import type { ReactNode } from 'react';
import clsx from 'clsx';
import { LockClosedIcon } from '@heroicons/react/24/solid';

export const MOTIVO_SEM_PERMISSAO_POST = 'Só quem tem a permissão "Publicar no Portal" pode fazer isso.';

interface AcaoBloqueadaProps {
  children: ReactNode;
  className?: string;
  /** Texto da dica (padrão: precisa de "Publicar no Portal"). */
  motivo?: string;
}

/**
 * Botão de ação visível mas bloqueado: cadeado sutil no canto e, ao passar o mouse (ou tocar, no
 * celular — o botão recebe foco), a dica explicando quem pode. Usado nos posts pro Administrar SI,
 * que vê tudo em modo leitura.
 */
export function AcaoBloqueada({ children, className, motivo = MOTIVO_SEM_PERMISSAO_POST }: AcaoBloqueadaProps) {
  return (
    <span className="group relative inline-flex">
      <button
        type="button"
        aria-disabled="true"
        aria-label={`${typeof children === 'string' ? children : 'Ação'} — ${motivo}`}
        className={clsx('relative cursor-not-allowed pr-2.5 text-raro-gray-400 focus:outline-none', className)}
        onClick={(event) => event.preventDefault()}
      >
        {children}
        <LockClosedIcon className="absolute -right-0.5 -top-1 h-2.5 w-2.5 text-raro-gray-400" aria-hidden="true" />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-0 z-20 mb-1.5 hidden w-56 rounded-lg bg-raro-gray-900 px-2.5 py-1.5 text-[11px] font-normal leading-snug text-white shadow-lg group-hover:block group-focus-within:block"
      >
        {motivo}
      </span>
    </span>
  );
}
